<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <HeaderPadrao class="mb-3" icon="fa fa-exchange" titulo="CADASTRO DE TIPO DE MOVIMENTAÇÃO">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap w-100">
            <div class="d-flex align-items-center mr-4">
              <span class="mr-2">
                <i class="fa fa-barcode mr-1 text-info"></i>
                CÓDIGO: <strong class="text-white">{{registro.ID || 'Novo'}}</strong>
              </span>
              <span v-if="registro.DESCRICAO" class="mx-2 opacity-50">•</span>
              <span v-if="registro.DESCRICAO" class="mr-2">
                <i class="fa fa-tag mr-1 text-info"></i>
                {{registro.DESCRICAO}}
              </span>
            </div>
            
            <div class="d-flex align-items-center">
              <b-badge :variant="registro.SITUACAO === '1' ? 'success' : 'danger'" pill class="px-3 py-1 shadow-sm mr-2 border border-white-50">
                {{registro.SITUACAO === '1' ? 'ATIVO' : 'INATIVO'}}
              </b-badge>
            </div>
          </div>
        </template>

        <template #acoes>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold shadow-sm" @click.stop.prevent="postOrEdit()">
            <i class="fa fa-save mr-1"></i> GRAVAR
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar()">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </HeaderPadrao>

      <b-row class="px-2">
        <b-col sm="12">
          
          <!-- Card: Identificação -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-0" style="overflow: visible;">
            <div class="bg-light p-3 border-bottom d-flex align-items-center">
              <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center shadow-sm" style="width: 35px; height: 35px;">
                <i class="fa fa-id-card"></i>
              </div>
              <div>
                <h6 class="mb-0 font-weight-bold text-dark">Identificação e Dados Básicos</h6>
                <small class="text-muted">Informações essenciais do tipo de movimentação</small>
              </div>
            </div>
            
            <div class="p-4">
              <b-row>
                <b-col sm="2">
                  <label class="modal-label-premium">Código</label>
                  <b-form-input type="text" :disabled="true" class="rounded-pill bg-gray-100 border-0 font-weight-bold text-center" placeholder="Auto" v-model="registro.ID"></b-form-input>
                </b-col>
                <b-col sm="10">
                  <label class="modal-label-premium">Descrição</label>
                  <b-form-input type="text" id="edDESCRICAO" ref="edDESCRICAO" class="rounded-pill shadow-xs font-weight-bold"
                    placeholder="Nome do tipo de movimentação"
                    v-model="registro.DESCRICAO"
                    :state="!!registro.DESCRICAO"> </b-form-input>
                </b-col>
              </b-row> 

              <b-row class="mt-3">
                <b-col sm="3">
                  <label class="modal-label-premium">CFOP</label>
                  <CFOPDropDown 
                    v-model="registro.CFOP_ID"
                    class="rounded-pill"
                    placeholder="Selecione o CFOP..." />
                </b-col>
                <b-col sm="3">
                  <label class="modal-label-premium">Forma de Operação</label>
                  <b-form-select 
                    v-model="registro.FORMA" 
                    class="rounded-pill"
                    :options="optionsForma">
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <label class="modal-label-premium">Texto NFE</label>
                  <TextosNfeDropDown 
                    v-model="registro.TEXTO_NFE_ID"
                    class="rounded-pill"
                    placeholder="Selecione o Texto NFE..." />
                </b-col>
                <b-col sm="3">
                  <label class="modal-label-premium">Situação</label>
                  <b-form-select 
                    v-model="registro.SITUACAO" 
                    class="rounded-pill"
                    :options="optionsSituacao">
                  </b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-card>

          <!-- Card: Operações -->
          <b-card class="border-0 shadow-sm mb-4 overflow-hidden" body-class="p-0">
            <div class="bg-light p-3 border-bottom d-flex align-items-center">
              <div class="bg-info text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center shadow-sm" style="width: 35px; height: 35px;">
                <i class="fa fa-cogs"></i>
              </div>
              <div>
                <h6 class="mb-0 font-weight-bold text-dark">Configurações de Operação</h6>
                <small class="text-muted">Parâmetros de movimentação</small>
              </div>
            </div>
            
            <div class="p-4">
              <b-row>
                <b-col sm="3">
                  <label class="modal-label-premium">Tipo de Movimentação</label>
                  <b-form-select 
                    v-model="registro.OP_TIPO_MOVIMENTACAO" 
                    class="rounded-pill"
                    :options="optionsTipoMovimentacao">
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <label class="modal-label-premium">Movimenta Estoque</label>
                  <b-form-select 
                    v-model="registro.OP_MOVIMENTA_ESTOQUE" 
                    class="rounded-pill"
                    :options="optionsMovimentaEstoque">
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <label class="modal-label-premium">Gera Financeiro</label>
                  <b-form-select 
                    v-model="registro.OP_GERA_FINANCEIRO" 
                    class="rounded-pill"
                    :options="optionsGeraFinanceiro">
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <label class="modal-label-premium">Gera ICMS</label>
                  <b-form-select 
                    v-model="registro.GERA_IMPOSTO_ICMS" 
                    class="rounded-pill"
                    :options="optionsSimNao">
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col sm="3">
                  <label class="modal-label-premium">Destino Operação</label>
                  <b-form-select 
                    v-model="registro.OP_DESTINO_OPERACAO" 
                    class="rounded-pill"
                    :options="optionsDestinoOperacao">
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <label class="modal-label-premium">Finalidade Emissão</label>
                  <b-form-select 
                    v-model="registro.OP_FINALIDADE_EMISSAO" 
                    class="rounded-pill"
                    :options="optionsFinalidadeEmissao">
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <label class="modal-label-premium">Tipo Produto</label>
                  <b-form-select 
                    v-model="registro.OP_PRODUTO" 
                    class="rounded-pill"
                    :options="optionsTipoProduto">
                  </b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-card>

          <!-- Card: Matriz CFOP NF-e -->
          <b-card v-if="habilitaDetalhes" class="border-0 shadow-sm mb-4 overflow-hidden" body-class="p-0">
            <div class="bg-light p-3 border-bottom d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center shadow-sm" style="width: 35px; height: 35px;">
                  <i class="fa fa-random"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold text-dark">Matriz CFOP NF-e</h6>
                  <small class="text-muted">CFOP por destino, finalidade e consumidor final</small>
                </div>
              </div>
              <b-button
                variant="success"
                pill
                class="px-4 shadow-sm"
                :disabled="!cfopRegraTabelaConfigurada"
                @click="novaCfopRegra()">
                <i class="fa fa-plus mr-1"></i> Adicionar Regra
              </b-button>
            </div>

            <div class="p-3">
              <b-alert v-if="!cfopRegraTabelaConfigurada" show variant="warning" class="mb-3">
                {{cfopRegraMensagem}}
              </b-alert>

              <b-table
                striped
                hover
                show-empty
                empty-text="Nenhuma regra CFOP cadastrada"
                small
                class="table-finance mb-0"
                bordered
                responsive
                :items="listaCfopRegras"
                :fields="fieldsCfopRegras">
                <template #cell(OP_DESTINO_OPERACAO)="item">
                  {{traduzirDestinoOperacao(item.value)}}
                </template>
                <template #cell(OP_FINALIDADE_EMISSAO)="item">
                  {{traduzirFinalidadeEmissao(item.value)}}
                </template>
                <template #cell(OP_CONSUMIDOR_FINAL)="item">
                  {{traduzirConsumidorFinal(item.value)}}
                </template>
                <template #cell(CFOP_ID)="item">
                  {{item.value}}{{item.item.CFOP_NATUREZA ? ' - ' + item.item.CFOP_NATUREZA : ''}}
                </template>
                <template #cell(SITUACAO)="item">
                  <b-badge :variant="item.value === 'A' ? 'success' : 'secondary'" pill>
                    {{item.value === 'A' ? 'ATIVA' : 'INATIVA'}}
                  </b-badge>
                </template>
                <template #cell(actions)="item">
                  <b-button
                    type="button"
                    size="sm"
                    variant="soft-primary"
                    pill
                    class="mr-1"
                    @click.stop="editarCfopRegra(item.item)"
                    v-b-tooltip.hover title="Editar">
                    <i class="fa fa-edit"></i>
                  </b-button>
                  <b-button
                    type="button"
                    size="sm"
                    variant="soft-danger"
                    pill
                    :disabled="item.item.SITUACAO !== 'A'"
                    @click.stop="inativarCfopRegra(item.item)"
                    v-b-tooltip.hover title="Inativar">
                    <i class="fa fa-ban"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
          </b-card>

          <!-- Card: Reforma Tributária -->
          <b-card v-if="habilitaDetalhes" class="border-0 shadow-sm mb-4 overflow-hidden" body-class="p-0">
            <div class="bg-light p-3 border-bottom d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="bg-success text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center shadow-sm" style="width: 35px; height: 35px;">
                  <i class="fa fa-list"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold text-dark">Reforma Tributária</h6>
                  <small class="text-muted">Configurações de tributação IBS/CBS/IS</small>
                </div>
              </div>
            </div>
            
            <div class="p-4">
              <b-row>
                <b-col sm="2">
                  <label class="modal-label-premium">Tipo NF Crédito</label>
                  <b-form-select 
                    v-model="registro.OP_TP_NF_CREDITO" 
                    class="rounded-pill"
                    :options="optionsTpNfCredito">
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Tipo NF Débito</label>
                  <b-form-select 
                    v-model="registro.OP_TP_NF_DEBITO" 
                    class="rounded-pill"
                    :options="optionsTpNfDebito">
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Ente Governamental</label>
                  <b-form-select 
                    v-model="registro.OP_TP_ENTE_GOV_PADRAO" 
                    class="rounded-pill"
                    :options="optionsEnteGov">
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Operador Gov</label>
                  <b-form-select 
                    v-model="registro.OP_TP_OPER_GOV_PADRAO" 
                    class="rounded-pill"
                    :options="optionsOperGov">
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Nº Redutor Padrão</label>
                  <vue-autonumeric  
                    v-model="registro.NR_REDUTOR_PADRAO" 
                    :options="formatoPercentual"
                    class="form-control rounded-pill text-right">
                  </vue-autonumeric>
                </b-col>
              </b-row>
            </div>
          </b-card>

          <!-- Card: Lista de NCM -->
          <b-card v-if="habilitaDetalhes" class="border-0 shadow-sm mb-4 overflow-hidden" body-class="p-0">
            <div class="bg-light p-3 border-bottom d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="bg-warning text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center shadow-sm" style="width: 35px; height: 35px;">
                  <i class="fa fa-hashtag"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold text-dark">Ranges de NCM</h6>
                  <small class="text-muted">Configurações de faixas de NCM para tributação</small>
                </div>
              </div>
              <b-button variant="success" pill class="px-4 shadow-sm" @click="novoNcm()">
                <i class="fa fa-plus mr-1"></i> Adicionar NCM
              </b-button>
            </div>
            
            <div class="p-3">
              <b-table 
                striped 
                hover 
                show-empty
                empty-text="Nenhum Range de NCM cadastrado"
                small
                class="table-finance mb-0"
                bordered
                responsive
                @row-clicked="selecionarNcm"
                :items="listaNCM" 
                :fields="fieldsNCM">
                <template #cell(actions)="item">
                  <b-button 
                    type="button" 
                    size="sm" 
                    variant="soft-primary"  
                    pill
                    class="mr-1"
                    @click.stop="editarNcm(item.item)"
                    v-b-tooltip.hover title="Editar">
                    <i class="fa fa-edit"></i>
                  </b-button>
                  <b-button 
                    type="button" 
                    size="sm" 
                    variant="soft-danger"  
                    pill
                    @click.stop="deleteNcm(item.item)"
                    v-b-tooltip.hover title="Remover">
                    <i class="fa fa-times"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
          </b-card>

          <!-- Card: Lista de Impostos -->
          <b-card v-if="habilitaDetalhes && ncmSelecionado" class="border-0 shadow-sm mb-4 overflow-hidden" body-class="p-0">
            <div class="bg-light p-3 border-bottom d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="bg-danger text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center shadow-sm" style="width: 35px; height: 35px;">
                  <i class="fa fa-percent"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold text-dark">Impostos IBS/CBS/IS</h6>
                  <small class="text-muted">NCM Selecionado: {{ncmSelecionado.NCM_INI}} - {{ncmSelecionado.NCM_FIM}}</small>
                </div>
              </div>
            </div>
            
            <div class="p-3">
              <b-table 
                striped 
                hover 
                show-empty
                empty-text="Nenhum Imposto cadastrado"
                small
                class="table-finance mb-0"
                bordered
                responsive
                :items="listaImpostos" 
                :fields="fieldsImpostos">
                <template #cell(CST_IBSCBS)="item">
                  {{traduzirCst(item.value)}}
                </template>
                <template #cell(ALIQUOTA_IBS)="item">
                  {{formatarPercentual(item.value)}}
                </template>
                <template #cell(PREDALIQ_IBS)="item">
                  {{formatarPercentual(item.value)}}
                </template>
                <template #cell(ALIQUOTA_CBS)="item">
                  {{formatarPercentual(item.value)}}
                </template>
                <template #cell(PREDALIQ_CBS)="item">
                  {{formatarPercentual(item.value)}}
                </template>
                <template #cell(ALIQUOTA_IS)="item">
                  {{formatarPercentual(item.value)}}
                </template>
                <template #cell(ATIVO)="item">
                  <b-badge :variant="item.value === '1' ? 'success' : 'danger'" pill>
                    {{item.value === '1' ? 'ATIVO' : 'INATIVO'}}
                  </b-badge>
                </template>
                <template #cell(VIGENCIA_INI)="item">
                  {{item.value ? formatarData(item.value) : '-'}}
                </template>
                <template #cell(VIGENCIA_FIM)="item">
                  {{item.value ? formatarData(item.value) : '-'}}
                </template>
                <template #cell(actions)="item">
                  <b-button 
                    type="button" 
                    size="sm" 
                    variant="soft-primary"  
                    pill
                    @click.stop="editarImposto(item.item)"
                    v-b-tooltip.hover title="Editar">
                    <i class="fa fa-edit"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
          </b-card>

        </b-col>
      </b-row>
    </div>

    <!-- Modal NCM -->
    <b-modal 
      ref="modalNcm" 
      id="modal-ncm" 
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      centered
      body-class="p-0"
      size="md"
      content-class="border-0 shadow-lg">
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
           style="background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%) !important;">
        <div class="header-icon-wrapper mr-3 bg-white-10">
          <i class="fa fa-barcode text-white"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold text-white">{{modalNcmData.emAlteracao ? 'Editar' : 'Adicionar'}} Range de NCM</h5>
          <small class="text-white opacity-75">Informe a faixa de NCM</small>
        </div>
        <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs.modalNcm.hide()">
          <i class="fa fa-times fa-lg"></i>
        </b-button>
      </div>

      <div class="p-4">
        <b-row>
          <b-col sm="6">
            <label class="modal-label-premium">NCM Inicial</label>
            <b-form-input 
              type="text" 
              v-model="modalNcmData.ncmIni" 
              maxlength="8"
              class="rounded-pill"
              placeholder="00000000">
            </b-form-input>
          </b-col>
          <b-col sm="6">
            <label class="modal-label-premium">NCM Final</label>
            <b-form-input 
              type="text" 
              v-model="modalNcmData.ncmFim" 
              maxlength="8"
              class="rounded-pill"
              placeholder="99999999">
            </b-form-input>
          </b-col>
        </b-row>
      </div>

      <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
        <b-button variant="light" pill class="px-4 mr-2 font-weight-bold" @click="$refs.modalNcm.hide()">
          CANCELAR
        </b-button>
        <b-button variant="warning" pill class="px-4 shadow-sm font-weight-bold text-white" @click="salvarNcm()">
          <i class="fa fa-check mr-1"></i> SALVAR
        </b-button>
      </div>
    </b-modal>

    <!-- Modal Imposto -->
    <b-modal 
      ref="modalImposto" 
      id="modal-imposto" 
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      centered
      body-class="p-0"
      size="xl"
      content-class="border-0 shadow-lg">
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
           style="background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;">
        <div class="header-icon-wrapper mr-3 bg-white-10">
          <i class="fa fa-percent text-white"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold text-white">Editar Imposto</h5>
          <small class="text-white opacity-75">Configurações de tributação</small>
        </div>
        <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs.modalImposto.hide()">
          <i class="fa fa-times fa-lg"></i>
        </b-button>
      </div>

      <div class="p-4">
        <b-row>
          <b-col sm="2">
            <label class="modal-label-premium">UF Destino</label>
            <b-form-input 
              type="text" 
              v-model="modalImpostoData.registro.UF_DESTINO_ID" 
              disabled
              class="rounded-pill bg-light">
            </b-form-input>
          </b-col>
          <b-col sm="2">
            <label class="modal-label-premium">Ativo</label>
            <b-form-select 
              v-model="modalImpostoData.registro.ATIVO" 
              class="rounded-pill"
              :options="optionsAtivoInativo">
            </b-form-select>
          </b-col>
          <b-col sm="4">
            <label class="modal-label-premium">CST IBS/CBS</label>
            <b-form-select 
              v-model="modalImpostoData.registro.CST_IBSCBS" 
              class="rounded-pill"
              :options="cstIbscbsOptions">
            </b-form-select>
          </b-col>
          <b-col sm="2">
            <label class="modal-label-premium">Class Trib IBS/CBS</label>
            <b-form-input 
              type="text" 
              v-model="modalImpostoData.registro.CLASSTRIB_IBSCBS" 
              maxlength="6"
              class="rounded-pill">
            </b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col sm="3">
            <label class="modal-label-premium">Alíquota IBS (%)</label>
            <vue-autonumeric 
              v-model="modalImpostoData.registro.ALIQUOTA_IBS" 
              :options="formatoPercentual"
              class="form-control rounded-pill text-right">
            </vue-autonumeric>
          </b-col>
          <b-col sm="3">
            <label class="modal-label-premium">Pred Aliq IBS UF (%)</label>
            <vue-autonumeric 
              v-model="modalImpostoData.registro.PREDALIQ_IBS" 
              :options="formatoPercentual"
              class="form-control rounded-pill text-right">
            </vue-autonumeric>
          </b-col>
          <b-col sm="3">
            <label class="modal-label-premium">Alíquota CBS (%)</label>
            <vue-autonumeric 
              v-model="modalImpostoData.registro.ALIQUOTA_CBS" 
              :options="formatoPercentual"
              class="form-control rounded-pill text-right">
            </vue-autonumeric>
          </b-col>
          <b-col sm="3">
            <label class="modal-label-premium">Pred Aliq CBS (%)</label>
            <vue-autonumeric 
              v-model="modalImpostoData.registro.PREDALIQ_CBS" 
              :options="formatoPercentual"
              class="form-control rounded-pill text-right">
            </vue-autonumeric>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col sm="3">
            <label class="modal-label-premium">Alíquota IS (%)</label>
            <vue-autonumeric 
              v-model="modalImpostoData.registro.ALIQUOTA_IS" 
              :options="formatoPercentual"
              class="form-control rounded-pill text-right">
            </vue-autonumeric>
          </b-col>
          <b-col sm="3">
            <label class="modal-label-premium">Vigência Início</label>
            <CecInputData 
              v-model="modalImpostoData.registro.VIGENCIA_INI" 
              class="rounded-pill">
            </CecInputData>
          </b-col>
          <b-col sm="3">
            <label class="modal-label-premium">Vigência Fim</label>
            <CecInputData 
              v-model="modalImpostoData.registro.VIGENCIA_FIM" 
              class="rounded-pill">
            </CecInputData>
          </b-col>
        </b-row>
      </div>

      <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
        <b-button variant="light" pill class="px-4 mr-2 font-weight-bold" @click="$refs.modalImposto.hide()">
          CANCELAR
        </b-button>
        <b-button variant="danger" pill class="px-4 shadow-sm font-weight-bold text-white" @click="salvarImposto()">
          <i class="fa fa-check mr-1"></i> SALVAR
        </b-button>
      </div>
    </b-modal>

    <!-- Modal Regra CFOP -->
    <b-modal
      ref="modalCfopRegra"
      id="modal-cfop-regra"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      centered
      body-class="p-0"
      size="lg"
      content-class="border-0 shadow-lg">
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark">
        <div class="header-icon-wrapper mr-3 bg-white-10">
          <i class="fa fa-random text-white"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold text-white">{{modalCfopRegraData.emAlteracao ? 'Editar' : 'Adicionar'}} Regra CFOP</h5>
          <small class="text-white opacity-75">Matriz fiscal usada pelo motor de NF-e</small>
        </div>
        <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs.modalCfopRegra.hide()">
          <i class="fa fa-times fa-lg"></i>
        </b-button>
      </div>

      <div class="p-4">
        <b-row>
          <b-col sm="4">
            <label class="modal-label-premium">Destino</label>
            <b-form-select
              v-model="modalCfopRegraData.registro.OP_DESTINO_OPERACAO"
              class="rounded-pill"
              :options="optionsDestinoOperacaoMatriz">
            </b-form-select>
          </b-col>
          <b-col sm="4">
            <label class="modal-label-premium">Finalidade</label>
            <b-form-select
              v-model="modalCfopRegraData.registro.OP_FINALIDADE_EMISSAO"
              class="rounded-pill"
              :options="optionsFinalidadeEmissaoMatriz">
            </b-form-select>
          </b-col>
          <b-col sm="4">
            <label class="modal-label-premium">Consumidor final</label>
            <b-form-select
              v-model="modalCfopRegraData.registro.OP_CONSUMIDOR_FINAL"
              class="rounded-pill"
              :options="optionsConsumidorFinalMatriz">
            </b-form-select>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col sm="8">
            <label class="modal-label-premium">CFOP</label>
            <CFOPDropDown
              v-model="modalCfopRegraData.registro.CFOP_ID"
              class="rounded-pill"
              placeholder="Selecione o CFOP..." />
          </b-col>
          <b-col sm="4">
            <label class="modal-label-premium">Situacao</label>
            <b-form-select
              v-model="modalCfopRegraData.registro.SITUACAO"
              class="rounded-pill"
              :options="optionsSituacaoCfopRegra">
            </b-form-select>
          </b-col>
        </b-row>
      </div>

      <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
        <b-button variant="light" pill class="px-4 mr-2 font-weight-bold" @click="$refs.modalCfopRegra.hide()">
          CANCELAR
        </b-button>
        <b-button variant="primary" pill class="px-4 shadow-sm font-weight-bold text-white" @click="salvarCfopRegra()">
          <i class="fa fa-check mr-1"></i> SALVAR
        </b-button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import HeaderPadrao from '../../../components/Cec/HeaderPadrao.vue'
import CFOPDropDown from '../../componentes/dropdown/CFOPDropDown.vue'
import TextosNfeDropDown from '../../componentes/dropdown/TextosNfeDropDown.vue'
import VueAutonumeric from 'vue-autonumeric'
import CecInputData from '@/components/Cec/CecInputData.vue'
import Tools from '@/tools/tools.js'
import moment from 'moment'

export default {
  components: {
    HeaderPadrao,
    CFOPDropDown,
    TextosNfeDropDown,
    VueAutonumeric,
    CecInputData
  },
  data () {
    return {
      formatoPercentual: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '4',
        roundingMethod: 'U',
        minimumValue: 0,
        maximumValue: 100,
        suffixText: ' %',
        modifyValueOnWheel: false
      },
      registro: {
        ID: null,
        DESCRICAO: null,
        CFOP_ID: null,
        FORMA: null,
        TEXTO_NFE_ID: null,
        OP_TIPO_MOVIMENTACAO: null,
        OP_MOVIMENTA_ESTOQUE: null,
        OP_GERA_FINANCEIRO: null,
        OP_DESTINO_OPERACAO: null,
        OP_FINALIDADE_EMISSAO: null,
        USUARIO_CADASTRO: null,
        DATA_CADASTRO: null,
        SITUACAO: '1',
        GERA_IMPOSTO_ICMS: 'S',
        OP_PRODUTO: null,
        OP_TP_NF_CREDITO: null,
        OP_TP_NF_DEBITO: null,
        OP_TP_OPER_GOV_PADRAO: null,
        OP_TP_ENTE_GOV_PADRAO: null,
        NR_REDUTOR_PADRAO: null
      },
      listaNCM: [],
      ncmSelecionado: null,
      listaImpostos: [],
      listaCfopRegras: [],
      cfopRegraTabelaConfigurada: true,
      cfopRegraMensagem: '',
      modalNcmData: {
        emAlteracao: false,
        id: null,
        ncmIni: '',
        ncmFim: ''
      },
      modalImpostoData: {
        registro: {
          ID: null,
          TIPO_MOVIMENTACAO_ID: null,
          UF_DESTINO_ID: null,
          ALIQUOTA_IBS: null,
          ALIQUOTA_CBS: null,
          ALIQUOTA_IS: null,
          VIGENCIA_INI: null,
          VIGENCIA_FIM: null,
          ATIVO: '1',
          CST_IBSCBS: null,
          CLASSTRIB_IBSCBS: null,
          PREDALIQ_IBS: null,
          PREDALIQ_CBS: null
        }
      },
      modalCfopRegraData: {
        emAlteracao: false,
        registro: {
          ID: null,
          TIPO_MOVIMENTACAO_ID: null,
          OP_DESTINO_OPERACAO: null,
          OP_FINALIDADE_EMISSAO: null,
          OP_CONSUMIDOR_FINAL: null,
          CFOP_ID: null,
          SITUACAO: 'A'
        }
      },
      fieldsNCM: [
        { key: 'ID', label: 'ID', thStyle: { width: '10%' } },
        { key: 'NCM_INI', label: 'NCM Inicial', thStyle: { width: '35%' } },
        { key: 'NCM_FIM', label: 'NCM Final', thStyle: { width: '35%' } },
        { key: 'actions', label: 'Ações', thStyle: { width: '20%' }, class: 'text-center' }
      ],
      fieldsImpostos: [
        { key: 'UF_DESTINO_ID', label: 'UF', thStyle: { width: '5%' } },
        { key: 'ATIVO', label: 'Ativo', thStyle: { width: '5%' } },
        { key: 'CST_IBSCBS', label: 'CST', thStyle: { width: '15%' } },
        { key: 'CLASSTRIB_IBSCBS', label: 'Class Trib', thStyle: { width: '10%' } },
        { key: 'ALIQUOTA_IBS', label: 'Aliq IBS (%)', thStyle: { width: '8%' }, class: 'text-right' },
        { key: 'PREDALIQ_IBS', label: 'Pred IBS UF (%)', thStyle: { width: '8%' }, class: 'text-right' },
        { key: 'ALIQUOTA_CBS', label: 'Aliq CBS (%)', thStyle: { width: '8%' }, class: 'text-right' },
        { key: 'PREDALIQ_CBS', label: 'Pred CBS (%)', thStyle: { width: '8%' }, class: 'text-right' },
        { key: 'ALIQUOTA_IS', label: 'Aliq IS (%)', thStyle: { width: '8%' }, class: 'text-right' },
        { key: 'VIGENCIA_INI', label: 'Vigência Ini', thStyle: { width: '8%' } },
        { key: 'VIGENCIA_FIM', label: 'Vigência Fim', thStyle: { width: '8%' } },
        { key: 'actions', label: 'Ações', thStyle: { width: '9%' }, class: 'text-center' }
      ],
      fieldsCfopRegras: [
        { key: 'OP_DESTINO_OPERACAO', label: 'Destino', thStyle: { width: '18%' } },
        { key: 'OP_FINALIDADE_EMISSAO', label: 'Finalidade', thStyle: { width: '20%' } },
        { key: 'OP_CONSUMIDOR_FINAL', label: 'Consumidor', thStyle: { width: '16%' } },
        { key: 'CFOP_ID', label: 'CFOP', thStyle: { width: '24%' } },
        { key: 'SITUACAO', label: 'Situacao', thStyle: { width: '10%' }, class: 'text-center' },
        { key: 'actions', label: 'Acoes', thStyle: { width: '12%' }, class: 'text-center' }
      ],
      optionsForma: [
        { value: null, text: '' },
        { value: 'VENDA', text: 'Venda de Produtos' },
        { value: 'TROCA', text: 'Troca' },
        { value: 'BONIFICACAO', text: 'Bonificação' },
        { value: 'NEGOCIACAO', text: 'Negociação' },
        { value: 'ENTRADA', text: 'Entrada' },
        { value: 'COMPRA', text: 'Compra' },
        { value: 'TRANSFSAI', text: 'Transferência Saída' },
        { value: 'TRANSFENT', text: 'Transferência Entrada' },
        { value: 'OUTROS', text: 'Outros' }
      ],
      optionsSituacao: [
        { value: '1', text: 'Ativo' },
        { value: '0', text: 'Inativo' }
      ],
      optionsTipoMovimentacao: [
        { value: null, text: '' },
        { value: 'S', text: 'Saída' },
        { value: 'E', text: 'Entrada' }
      ],
      optionsMovimentaEstoque: [
        { value: null, text: 'Não gerar Op. no Estoque' },
        { value: '0', text: 'Debitar no Estoque' },
        { value: '1', text: 'Creditar no Estoque' },
        { value: '2', text: 'Creditar no Estoque (Devolução de Mercadoria)' }
      ],
      optionsGeraFinanceiro: [
        { value: null, text: 'Não gerar Titulo' },
        { value: '0', text: 'Gerar Titulo (Contas a Receber)' },
        { value: '1', text: 'Gerar Titulo (Contas a Pagar)' }
      ],
      optionsSimNao: [
        { value: 'S', text: 'Sim' },
        { value: 'N', text: 'Não' }
      ],
      optionsAtivoInativo: [
        { value: '1', text: 'Ativo' },
        { value: '0', text: 'Inativo' }
      ],
      optionsDestinoOperacao: [
        { value: null, text: '' },
        { value: '1', text: '1 - Operação Interna' },
        { value: '2', text: '2 - Operação Interestadual' },
        { value: '3', text: '3 - Operação Exterior' }
      ],
      optionsFinalidadeEmissao: [
        { value: null, text: '' },
        { value: '1', text: '1 - NF-e normal' },
        { value: '2', text: '2 - NF-e complementar' },
        { value: '3', text: '3 - NF-e de ajuste' },
        { value: '4', text: '4 - Devolução de Mercadoria' }
      ],
      optionsDestinoOperacaoMatriz: [
        { value: null, text: 'Qualquer destino' },
        { value: '1', text: '1 - Operacao interna' },
        { value: '2', text: '2 - Operacao interestadual' },
        { value: '3', text: '3 - Operacao exterior' }
      ],
      optionsFinalidadeEmissaoMatriz: [
        { value: null, text: 'Qualquer finalidade' },
        { value: '1', text: '1 - NF-e normal' },
        { value: '2', text: '2 - NF-e complementar' },
        { value: '3', text: '3 - NF-e de ajuste' },
        { value: '4', text: '4 - Devolucao de Mercadoria' }
      ],
      optionsConsumidorFinalMatriz: [
        { value: null, text: 'Qualquer consumidor' },
        { value: '0', text: '0 - Nao' },
        { value: '1', text: '1 - Sim' }
      ],
      optionsSituacaoCfopRegra: [
        { value: 'A', text: 'Ativa' },
        { value: 'I', text: 'Inativa' }
      ],
      optionsTipoProduto: [
        { value: null, text: '' },
        { value: 'P', text: 'P - Produto' },
        { value: 'M', text: 'M - Matéria/Bens' }
      ],
      optionsTpNfCredito: [
        { value: null, text: '' },
        { value: '01', text: '01 - Multa Juros' },
        { value: '02', text: '02 - Apropriação Crédito Presumido' },
        { value: '03', text: '03 - Retorno' },
        { value: '04', text: '04 - Redução Valores' },
        { value: '05', text: '05 - Transferência Crédito Sucessão' }
      ],
      optionsTpNfDebito: [
        { value: null, text: '' },
        { value: '01', text: '01 - Transferência Crédito Cooperativa' },
        { value: '02', text: '02 - Anulação' },
        { value: '03', text: '03 - Débitos Não Processadas' },
        { value: '04', text: '04 - Multa Juros' },
        { value: '05', text: '05 - Transferência Crédito Sucessão' },
        { value: '06', text: '06 - Pagamento Antecipado' },
        { value: '07', text: '07 - Perda Em Estoque' },
        { value: '08', text: '08 - Desenquadramento do SN' }
      ],
      optionsEnteGov: [
        { value: null, text: '' },
        { value: '1', text: '1 - União' },
        { value: '2', text: '2 - Estados' },
        { value: '3', text: '3 - Distrito Federal' },
        { value: '4', text: '4 - Municípios' }
      ],
      optionsOperGov: [
        { value: null, text: '' },
        { value: '1', text: '1 - Fornecimento' },
        { value: '2', text: '2 - Recebimento/Pagamento' }
      ],
      cstIbscbsOptions: [
        { value: '000', text: '000 - Tributada integralmente' },
        { value: '010', text: '010 - Tributada com cobrança de IBS e CBS por substituição tributária' },
        { value: '011', text: '011 - Tributada com cobrança de IBS e CBS por antecipação' },
        { value: '200', text: '200 - Isenta de IBS e CBS' },
        { value: '220', text: '220 - Imune de IBS e CBS' },
        { value: '221', text: '221 - Imune de CBS com incidência de IBS' },
        { value: '222', text: '222 - Imune de IBS com incidência de CBS' },
        { value: '400', text: '400 - Não tributada pelo IBS e CBS' },
        { value: '410', text: '410 - Não incidência de IBS e CBS' },
        { value: '510', text: '510 - Suspensão do IBS e CBS' },
        { value: '515', text: '515 - Diferimento de IBS e CBS' },
        { value: '550', text: '550 - IBS e CBS com desoneração' },
        { value: '620', text: '620 - Tributada pelo regime favorecido' },
        { value: '800', text: '800 - Exportação com direito a crédito' },
        { value: '810', text: '810 - Vendas de bens e serviços de varejo para uso e consumo com direito a crédito' },
        { value: '811', text: '811 - Operação com direito a crédito presumido' },
        { value: '820', text: '820 - Operação de importação para revenda com direito a crédito' },
        { value: '830', text: '830 - Crédito de bens de capital' }
      ]
    }
  },
  methods: {
    voltar() {
      this.$router.push('/cadastros/tipomovimentacao/index')
    },
    async postOrEdit () {
      if (this.avisos()) return
      
      try {
        this.$store.commit('controle/setAguardando', true)  
        
        const payload = {
          registro: this.registro,
          usuario: window.localStorage.getItem('login')
        }

        if (!this.registro.ID) {
          const { data } = await this.$http.post(`/api/protected/tipoMovimentacao/post`, payload)
          
          if (!data || data.result !== 'sucesso' || !data.registro) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível cadastrar!')  
            return
          }
          
          // Atualizar registro com os dados retornados pelo servidor
          this.registro = { ...data.registro }
          
          this.$store.commit("tipoMovimentacao/SET_LIMPAR", null)
          this.$store.commit("tipoMovimentacao/SET_REGISTRO_SELECIONADO_ID", this.registro.ID)
          this.$store.commit("tipoMovimentacao/SET_ID", this.registro.ID)
          this.$store.commit('tipoMovimentacao/SET_PAGINA_ATUAL', 1)
          await this.$store.dispatch('tipoMovimentacao/GET_LISTA')
          this.$store.commit("tipoMovimentacao/SET_LIMPAR_APENAS_FILTRO", null)

          // Atualizar rota para modo de edição
          this.$router.replace(`/cadastros/tipomovimentacao/edit/${this.registro.ID}`)

          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Tipo de Movimentação cadastrado com sucesso!')
          
          // Carregar dados adicionais após cadastro
          await Promise.all([
            this.carregarNCMs(false),
            this.carregarCfopRegras(false)
          ])

        } else {
          await this.$http.post(`/api/protected/tipoMovimentacao/edit`, payload)
          
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Tipo de Movimentação atualizado com sucesso!')
          this.$router.push('/cadastros/tipomovimentacao/index')
        }
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err.response?.data || 'Operação Indisponível!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)  
      }
    },
    async carregarNCMs(controlarLoading = true) {
      if (!this.registro.ID) return

      try {
        if (controlarLoading) this.$store.commit('controle/setAguardando', true)
        const { data } = await this.$http.get(`/api/protected/tipoMovimentacao/getNcms/${this.registro.ID}`, { timeout: 30000 })
        this.listaNCM = data || []
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível carregar os NCMs!')
      } finally {
        if (controlarLoading) this.$store.commit('controle/setAguardando', false)
      }
    },
    async carregarCfopRegras(controlarLoading = true) {
      if (!this.registro.ID) return

      try {
        if (controlarLoading) this.$store.commit('controle/setAguardando', true)
        const { data } = await this.$http.get(`/api/protected/nfeMotor/cfopRegras/${this.registro.ID}`, { timeout: 30000 })
        this.cfopRegraTabelaConfigurada = data ? data.tabelaConfigurada !== false : true
        this.cfopRegraMensagem = data && data.mensagem ? data.mensagem : ''
        this.listaCfopRegras = data && data.items ? data.items : []
      } catch(err) {
        console.log(err)
        this.cfopRegraTabelaConfigurada = false
        this.cfopRegraMensagem = err.response?.data || 'Nao foi possivel carregar a matriz CFOP.'
        this.listaCfopRegras = []
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', this.cfopRegraMensagem)
      } finally {
        if (controlarLoading) this.$store.commit('controle/setAguardando', false)
      }
    },
    novaCfopRegra() {
      this.modalCfopRegraData.emAlteracao = false
      this.modalCfopRegraData.registro = {
        ID: null,
        TIPO_MOVIMENTACAO_ID: this.registro.ID,
        OP_DESTINO_OPERACAO: null,
        OP_FINALIDADE_EMISSAO: null,
        OP_CONSUMIDOR_FINAL: null,
        CFOP_ID: null,
        SITUACAO: 'A'
      }
      this.$refs.modalCfopRegra.show()
    },
    editarCfopRegra(item) {
      this.modalCfopRegraData.emAlteracao = true
      this.modalCfopRegraData.registro = {
        ID: item.ID,
        TIPO_MOVIMENTACAO_ID: item.TIPO_MOVIMENTACAO_ID,
        OP_DESTINO_OPERACAO: item.OP_DESTINO_OPERACAO || null,
        OP_FINALIDADE_EMISSAO: item.OP_FINALIDADE_EMISSAO || null,
        OP_CONSUMIDOR_FINAL: item.OP_CONSUMIDOR_FINAL || null,
        CFOP_ID: item.CFOP_ID,
        SITUACAO: item.SITUACAO || 'A'
      }
      this.$refs.modalCfopRegra.show()
    },
    async salvarCfopRegra() {
      if (!this.modalCfopRegraData.registro.CFOP_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o CFOP da regra.')
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        const payload = {
          registro: {
            ...this.modalCfopRegraData.registro,
            TIPO_MOVIMENTACAO_ID: this.registro.ID
          },
          usuario: window.localStorage.getItem('login')
        }

        await this.$http.post('/api/protected/nfeMotor/cfopRegras/salvar', payload)
        await this.carregarCfopRegras(false)
        this.$refs.modalCfopRegra.hide()
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Regra CFOP salva com sucesso!')
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err.response?.data || 'Nao foi possivel salvar a regra CFOP.')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async inativarCfopRegra(item) {
      const msg = await this.$bvModal.msgBoxConfirm(`Inativar a regra CFOP ${item.CFOP_ID}?`, {
        title: 'Inativar regra',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'danger',
        okTitle: 'SIM',
        cancelTitle: 'NAO',
        footerClass: 'p-2',
        centered: true
      })

      if (!msg) return

      try {
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post(`/api/protected/nfeMotor/cfopRegras/inativar/${item.ID}`)
        await this.carregarCfopRegras(false)
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Regra CFOP inativada com sucesso!')
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err.response?.data || 'Nao foi possivel inativar a regra CFOP.')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async selecionarNcm(item) {
      this.ncmSelecionado = item
      await this.carregarImpostos(item.ID)
    },
    async carregarImpostos(tributacaoReformaId) {
      try {
        this.$store.commit('controle/setAguardando', true)
        const { data } = await this.$http.get(`/api/protected/tipoMovimentacao/getImpostos/${tributacaoReformaId}`)
        this.listaImpostos = data || []
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível carregar os impostos!')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    novoNcm() {
      this.modalNcmData.emAlteracao = false
      this.modalNcmData.id = null
      this.modalNcmData.ncmIni = ''
      this.modalNcmData.ncmFim = ''
      this.$refs.modalNcm.show()
    },
    editarNcm(item) {
      this.modalNcmData.emAlteracao = true
      this.modalNcmData.id = item.ID
      this.modalNcmData.ncmIni = item.NCM_INI
      this.modalNcmData.ncmFim = item.NCM_FIM
      this.$refs.modalNcm.show()
    },
    async salvarNcm() {
      if (!this.modalNcmData.ncmIni || !this.modalNcmData.ncmFim) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o range de NCM!')
        return
      }

      

      try {
        this.$store.commit('controle/setAguardando', true)

        if (this.modalNcmData.emAlteracao) {
          await this.$http.post(
            `/api/protected/tipoMovimentacao/editNCMS/${this.modalNcmData.id}/${this.modalNcmData.ncmIni}/${this.modalNcmData.ncmFim}`
          )
        } else {
          await this.$http.post(`/api/protected/tipoMovimentacao/postNCMS/${this.registro.ID}/${this.modalNcmData.ncmIni}/${this.modalNcmData.ncmFim}`)
        }

        await this.carregarNCMs(false)
        this.$refs.modalNcm.hide()
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Range de NCM salvo com sucesso!')

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err.response?.data || 'Não foi possível salvar!')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async deleteNcm(item) {
      const msg = await this.$bvModal.msgBoxConfirm(`Excluir o range de NCM: ${item.NCM_INI} - ${item.NCM_FIM} ?`, {
        title: 'Excluir',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'danger',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        centered: true
      })
      
      if (!msg) return

      try {
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post(`/api/protected/tipoMovimentacao/deleteNCMS/${item.ID}`)
        await this.carregarNCMs(false)
        
        if (this.ncmSelecionado && this.ncmSelecionado.ID === item.ID) {
          this.ncmSelecionado = null
          this.listaImpostos = []
        }

        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Range de NCM excluído com sucesso!')

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err.response?.data || 'Não foi possível excluir!')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    editarImposto(item) {
      this.modalImpostoData.registro = { ...item }
      this.$refs.modalImposto.show()
    },
    async salvarImposto() {
      try {
        this.$store.commit('controle/setAguardando', true)

        const payload = {
          registro: this.modalImpostoData.registro,
          usuario: window.localStorage.getItem('login')
        }

        await this.$http.post(`/api/protected/tipoMovimentacao/imposto/edit`, payload)

        if (this.ncmSelecionado) {
          await this.carregarImpostos(this.ncmSelecionado.ID)
        }

        this.$refs.modalImposto.hide()
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Imposto atualizado com sucesso!')

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err.response?.data || 'Não foi possível salvar!')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    avisos() {
      if (!this.registro.DESCRICAO) {
        this.$refs.edDESCRICAO.$refs.input.focus()
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a Descrição')
        return true
      }
      
      return false
    },
    formatarData(data) {
      return data ? moment(String(data)).format('DD/MM/YYYY') : '-'
    },
    traduzirCst(valor) {
      if (!valor) return '-'
      const opcao = this.cstIbscbsOptions.find(o => o.value === valor)
      return opcao ? opcao.text : valor
    },
    formatarPercentual(valor) {
      if (valor === null || valor === undefined) return '-'
      return Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) + ' %'
    },
    traduzirOption(options, valor, vazio = 'Qualquer') {
      if (valor === null || valor === undefined || valor === '') return vazio
      const opcao = options.find(o => o.value === valor)
      return opcao ? opcao.text : valor
    },
    traduzirDestinoOperacao(valor) {
      return this.traduzirOption(this.optionsDestinoOperacaoMatriz, valor)
    },
    traduzirFinalidadeEmissao(valor) {
      return this.traduzirOption(this.optionsFinalidadeEmissaoMatriz, valor)
    },
    traduzirConsumidorFinal(valor) {
      return this.traduzirOption(this.optionsConsumidorFinalMatriz, valor)
    }
  },
  computed: {
    habilitaDetalhes() {
      return this.registro.ID != null && this.registro.ID > 0
    }
  },
  async created () {
    const id = this.$route.params.id ? Number(this.$route.params.id) : null

    try {
      this.$store.commit('controle/setAguardando', true)

      if (id && id > 0) {
        const { data } = await this.$http.get(`/api/protected/tipoMovimentacao/getById/${id}`)
        if (data && data.length > 0) {
          this.registro = data[0]
          await Promise.all([
            this.carregarNCMs(false),
            this.carregarCfopRegras(false)
          ])
        }
      }

    } catch(err) {
      console.log(err)
      Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível carregar os dados!')
    } finally {
      this.$store.commit('controle/setAguardando', false)
    }
  }
}
</script>

<style scoped>
.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 600;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}

.table-finance thead th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 8px 12px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 8px 12px !important;
  color: #4a5568;
  font-size: 0.85rem;
}

.table-finance tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
  cursor: pointer;
}

.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.modal-footer-premium {
  background-color: #f8f9fa;
  border-top: 1px solid #edf2f7;
}

/* Garantir cantos arredondados nos dropdowns customizados */
::v-deep .cec-select-search .form-control {
  border-radius: 50rem !important;
}

::v-deep .cec-select-search .dropdown-menu {
  border-radius: 0.5rem !important;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/tipomovimentacao/TipoMovimentacaoCadastro.vue